import React, { useState, useEffect } from "react";
import axiosapi from "../api/axiosapi";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import 'katex/dist/katex.min.css';
import { InlineMath } from 'react-katex';
import Footer from "../components/Footer";
import useAuth from "../hooks/useAuth";

const splitContent = (sentence) => {
    const InlineMathRegex = /<InlineMath[^>]*>(.*?)<\/InlineMath>/g;
    const matches = sentence.matchAll(InlineMathRegex);
    let lastIndex = 0;
    const contentArray = [];
  
    for (const match of matches) {
        const InlineMathContent = <InlineMath key={lastIndex} math={match[1]} />;
        const restOfContent = sentence.substring(lastIndex, match.index);
    
        contentArray.push(restOfContent, InlineMathContent);
        lastIndex = match.index + match[0].length;
    }
  
    if (lastIndex < sentence.length) {
        contentArray.push(sentence.substring(lastIndex));
    }
  
    return <div>{contentArray}</div>;
};

const TodayProblemImage = () => {
    const {todayProblem, todayProblemList} = useLocation().state;
    const [count, setCount] = useState(0);
    const [problemOrder, setProblemOrder] = useState();
    const [problemList, setProblemList] = useState([]);
    const {auth, setAuth} = useAuth();
    const [loading, setLoading] = useState(true);

    useEffect (() => {
        const fetchToken = async () => {
            try {
                const response = await axiosapi.post('/refresh-token', {
                            withCredentials: true
                    });
                setAuth(prev => {
                    return { 
                    ...prev, 
                    userRole1: response.data.userRole1,
                    userRole2: response.data.userRole2,
                    accessToken: response.data.access_token 
                    }
                });
            } catch {
                setAuth(prev => {
                    return { 
                    ...prev, 
                    accessToken: null 
                    }
                }); // 로그인 안 된 상태
            } finally {
                setLoading(false);
            }
        }
        !auth?.accessToken && fetchToken();

        todayProblemList.map(prob => {
            if (prob.id === todayProblem.id) {
                setProblemOrder(prob.problemOrder);
                setCount(count+1);
            }
        })
    },[todayProblem])

    useEffect (() => {
        setProblemList([]);

        if (problemOrder <= 5) {
            let probList = todayProblemList.filter(prob => (prob.problemOrder != problemOrder && prob.problemOrder <= 11));
            setProblemList(probList);
        } else if (problemOrder >= todayProblemList.length-5) {
            let probList = todayProblemList.filter(prob => (prob.problemOrder != problemOrder && prob.problemOrder >= todayProblemList.length-11));
            setProblemList(probList);
            // todayProblemList.map(prob => {
            //     if (prob.problemOrder != problemOrder && prob.problemOrder >= todayProblemList.length-11) {
            //         setProblemList([...problemList, prob]);
            //     }
            // })
        } else {
            let probList = todayProblemList.filter(prob => (prob.problemOrder != problemOrder && prob.problemOrder >= problemOrder-5 && prob.problemOrder <= problemOrder+5));
            setProblemList(probList);
            // todayProblemList.map(prob => {
            //     if (prob.problemOrder != problemOrder && prob.problemOrder >= problemOrder-5 && prob.problemOrder >= problemOrder+5) {
            //         setProblemList([...problemList, prob]);
            //     }
            // })
        }
    },[count])

    console.log("problemOrder: ", problemOrder+1);
    console.log("todayProblemList: ", todayProblemList);
    console.log("problemList: ", problemList);

    // useEffect(() => {
    //     const controller = new AbortController();

    //     const fetchTodayProblem = async () => {
    //         try {
    //             const response = await axiosapi.get('/home/todayproblem/image/', {
    //                 params: {
    //                     id: todayProblem.id,
    //                     problemCode: todayProblem.problemCode
    //                 }
    //             })
    //             response.data && setTodayProblemList(response.data.todayProblemList);
    //             response.data && response.data.imageList.length > 0 && setImageList(response.data.imageList);
    //         } catch (err) {
    //             setErrPT(err.message);
    //             if (err.response) {
    //                 console.log(err.response.data);
    //                 console.log(err.response.status);
    //                 console.log(err.response.headers);
    //             } else {
    //                 console.log(`Error: ${err.message}`);
    //             }
    //         }
    //     }
    //     fetchTodayProblem();

    //     return () => controller.abort();
    // },[todayProblem])

    return(
        <div className="App-full-container">
            <div className="position-center-box-2-1">
                <h4 style={{color:"sienna", fontWeight:"bold"}}>즐거운 작도 세상</h4>
                <p>작도 문제를 소재로 한 재미있는 이야기를 읽고, 작도 문제를 풀어 보세요.</p>
                <Link 
                    to={`/todayproblemfi/${todayProblem.urlCode}`}
                    state={{
                        "todayProblemList": todayProblemList,
                        "todayProblem": todayProblem
                    }}
                >
                    <div style={{textAlign:"center"}}>{splitContent(todayProblem.todayProblemTitle)}</div>
                    <img src={`/image/${todayProblem.imageFile}`} style={{width:'100%', backgroundColor:`${todayProblem.backgroundColor}`}} />
                </Link>
            </div>
            {/* <div className="position-center-box-2-1">
                <h5 style={{marginTop:'25px', marginBottom:'18px', marginLeft:'8px', fontWeight:"bold"}}>그림이 와글와글</h5>
                {imageList.map(image => {
                    return(
                        <div key={image.id}>
                            <Link 
                                to={`/viewimage/${image.imageFile}/${image.backgroundColor}`}
                                target="_blank"
                            >
                                <p style={{marginLeft:'10px'}}>{image.coloringTitle}</p>
                            </Link>
                        </div>
                    )
                })}
            </div> */}
            <div className="position-center-box-2-1">
                <h5 style={{marginTop:'25px', marginBottom:'18px', fontWeight:"bold"}}>다른 작도 문제</h5>
                {problemList.map(todayProblem => {
                    return (
                        <div key={todayProblem.id}>
                            <Link 
                                to={`/todayproblem/image/${todayProblem.urlCode}`}
                                state={{
                                    "todayProblemList": todayProblemList,
                                    "todayProblem": todayProblem
                                }}
                            >
                                <div style={{marginLeft:'2px'}}>{splitContent(todayProblem.todayProblemTitle)}</div>
                            </Link>
                        </div>
                    )
                })}
            </div>
            {/* <div className="boxHome-10">
                <div>
                    <SideMenu />
                </div>
            </div> */}
            <div style={{width:"100%"}}>
                <Footer/>
            </div>
        </div>
    );
}

export default TodayProblemImage;
